export default __webpack_public_path__ + "static/media/empty1.69d3f4a5.jpg";